module.exports = __webpack_public_path__ + "media/images/element/abc-2e538753add3a0fdaa37fffe97952e13.svg";